import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { PaymentTerm } from 'src/app/assabil-kernel/models/entities/control-tables/payment-term';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { PaymentTermRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/payment-term-request';


@Component({
  selector: 'app-payment-term-list',
  templateUrl: './payment-term-list.component.html',
  styleUrls: ['./payment-term-list.component.scss']
})
export class PaymentTermListComponent extends BasePage2<PaymentTerm > {

  // Filter fields
  // ---------------------------------------------------
  code: string;
  name: string;
  discount : number;
  minimumAmount : number;
  maximumAmount : number;
  fixedTaxRate : number;
  fixedTaxMinimum : number;
  fixedTaxMaximum : number;
  // ---------------------------------------------------
      
  // ---------------------------------------------------
  paymentTerms: PaymentTerm[] = [];
  // ---------------------------------------------------


  constructor(
      protected toastr            : ToastrService,
      protected controlService    : ControlTablesService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = 'paymentTerm';
  }



  listFields = [
      { prop: 'paymentTermCode',            name: 'Code',           insertOnly : true},
      { prop: 'name',                       name: 'Name' },
      { prop: 'rank',                       name: 'Rang',           type :'number' },
      { prop: 'discount',                   name: 'Reduction',      type :'number' },
      { prop: 'minimumAmount',              name: 'Min',            type :'number' },
      { prop: 'maximumAmount',              name: 'Max',            type :'number' },
      { prop: 'fixedTaxApplyable',          name: 'Timbre',         type :'boolean'},
      { prop: 'fixedTaxRate',               name: 'Taux fixe',      type :'number' },
      { prop: 'fixedTaxMaximum',            name: 'Taux max fixe',  type :'number' },
      { prop: 'fixedTaxMinimum',            name: 'Taux min fixe',  type :'number' },
      { prop: 'fixedRoundingDecimal',       name: 'Approximation decimale', type :'number' },
      { prop: 'impactFinancialBalance',     name: 'Impact Financier',       type :'boolean' },
  ]


//----------------------------------------------------------------------
getRows(): PaymentTerm[] {
    return this.paymentTerms;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(paymentTerm: PaymentTerm): Promise<PaymentTerm> {
  let request  : PaymentTermRequest = new PaymentTermRequest(this.controlService.getUserInfo());
  request.paymentTerm = paymentTerm;
    return this.controlService.save(this.entityName, request);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let entity : PaymentTerm = new PaymentTerm();
  entity.inserted = true;
  entity.edit = true;
  this.paymentTerms.push(entity);
  this.paymentTerms = [...this.paymentTerms];
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
loadData() {
    let request         : BaseRequest = this.controlService.getRequest();
    request.strArg1 = this.code;
    request.strArg2 = this.name;

    this.controlService.getList(this.entityName, request).then(result => {
        this.paymentTerms = result;
        
    }).catch(error => {
        this.showError(error);
    })
  }
//----------------------------------------------------------------------

}

